import {WinPresentationController} from "./WinPresentationController";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class WinPresentationManager {

    private readonly _presentations: WinPresentationController[];

    constructor(presentations: WinPresentationController[]) {
        this._presentations = presentations.concat();
    }

    public async startInLine(flowStateController: FlowStateController): Promise<void> {
        for (const p of this._presentations) {
            await p.start(flowStateController);
        }
    }
}